import axios from '@/plugins/axios'
import BaseService from './base'

export default class UserService extends BaseService {
  static resource() {
    return 'api/v1/users'
  }
  static async sendEmailConfirmation(email, lang) {
    try {
      await axios.get('/sanctum/csrf-cookie')
      const { data } = await axios.post(
        `${this.baseURL()}/api/v1/forget-password`,
        {
          env: false,
          email: email,
          lang: lang
        }
      )
      return data
    } catch (e) {
      throw e.response.data.message
    }
  }

  static async sendEmailUserRecoveryConfirmation(email) {
    try {
      await axios.get('/sanctum/csrf-cookie')
      const { data } = await axios.post(
        `${this.baseURL()}/api/v1/forget-username`,
        {
          env: false,
          email_alternative: email
        }
      )
      return data
    } catch (e) {
      throw e.response.data.message
    }
  }

  static async updatePassword(user, env) {
    try {
      await axios.get('/sanctum/csrf-cookie')
      const { data } = await axios.post(
        `${this.baseURL()}/api/v1/reset-password`,
        {
          env: env,
          token: user.token,
          email: user.email,
          password: user.password,
          password_confirmation: user.password_confirmation
        }
      )
      return data
    } catch (e) {
      throw e.response.data.message
    }
  }

  static async sendEmailReset(email, env) {
    try {
      await axios.get('/sanctum/csrf-cookie')
      const { data } = await axios.post(
        `${this.baseURL()}/api/v1/restart-password`,
        {
          env: env,
          email: email
        }
      )
      return data
    } catch (e) {
      throw e.response.data.message
    }
  }

  static async me() {
    const { data } = await axios.get(`${this.baseURL()}/api/v1/me`)
    return data
  }
}
